import { keyframes } from "@fluentui/react";

export const borderAnim = keyframes({
    '0%': {
        transform: 'scaleX(0)'
    },
    '100%': {
        transform: 'scaleX(100%)'
    },
})